<template>
  <div class="p-6">
    <div class="flex flex-row py-2 border-b border-theme-39">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        โรคประจำตัว
      </div>
      <div
        class="w-8/12 lg:w-8/12 flex flex-wrap justify-start items-center px-2"
      >
        <!-- <XCircleIcon class="h-6 w-6 text-theme-36" v-if="chronic_disease.length==0" /> -->
        <div
          class="px-1.5 py-1 m-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1"
          v-for="(data,key) in chronic_disease"
          :key="key"
        >
          {{`${data.desc == "อื่นๆ" ? data.desc +' ('+data.disease_name+')' : data.desc}`}}
        </div>
      </div>
    </div>
    <div class="flex flex-row py-2 border-b border-theme-39">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        สิทธิการรักษาพยาบาล
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2 flex-wrap">
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center m-1"
          v-for="(data,key) in med_scheme"
          :key="key"
        >
        {{data.ofc_owner ? data.desc +' ซึ่งเป็นสิทธิของ'+data.ofc_owner : data.desc}}
        </div>
      </div>
    </div>
    <!-- <div class="col-span-12 flex items-center mt-2" v-show="is_disabled?.valueOf() != undefined || is_disabled || dep_person_subtype || dep_permit_date || dep_card_issue_date || dep_card_expire_date">
      <label class="font-medium text-base">
        ลักษณะความพิการ
      </label>
      <img class="ml-2 w-9 bg-gray-100 rounded-full text-center" style="border:1px solid lightpink;" src="@/assets/images/icon/main/issue_based/disabled.png">
    </div> -->
    <!-- <div class="flex flex-row py-2 border-b border-theme-39"> -->
    <div class="flex flex-row py-2">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        <span>ลักษณะความพิการ</span>
        <img
          v-show="is_DEPlinkingsystem"
          class="ml-2 w-9 bg-gray-100 rounded-full text-center"
          style="border:1px solid lightpink;"
          src="@/assets/images/icon/main/issue_based/disabled.png"
          :title="`ระบบทะเบียนคนพิการ กรมส่งเสริมและพัฒนาคุณภาพชีวิตคนพิการ (DEP)${
            props.information?.linking_system?.find(i => i.system === 'DEP')?.updated_at
              ? '\nข้อมูล ณ วันที่: ' + props.information.linking_system.find(i => i.system === 'DEP').updated_at
              : ''
          }`"
        >
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2">
        <!-- <XCircleIcon class="h-6 w-6 text-theme-36" v-if="!is_disabled"/> -->
        <!-- ภ้าไม่มีความพิการก็ไม่ต้องแสดงประเภทความพิการ -->
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1"
          v-if="is_disabled?.valueOf() != undefined"
        >
          {{`${is_disabled?.valueOf() != undefined ? is_disabled ? "พิการ" : "ไม่พิการ" : ""}`}}
        </div>
      </div>
    </div>
    <div class="flex flex-row py-2" v-if="is_disabled">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        ประเภทความพิการ
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2 flex-wrap">
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center m-1"
          v-for="(data,key) in disability"
          :key="key"
        >
          {{data.desc}}
        </div>
      </div>
    </div>
        <div class="flex flex-row py-2"  v-if="dep_person_subtype">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        สถานะบุคคล
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2">
        <!-- <XCircleIcon class="h-6 w-6 text-theme-36" v-if="!is_disabled"/> -->
        <!-- ถ้าไม่มีความพิการก็ไม่ต้องแสดงประเภทความพิการ -->
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1">
          {{`${dep_person_subtype}`}}
        </div>
      </div>
    </div>
    <div class="flex flex-row py-2"  v-if="dep_permit_date">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        วันที่อนุมัติขึ้นทะเบียน
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2">
        <!-- <XCircleIcon class="h-6 w-6 text-theme-36" v-if="!is_disabled"/> -->
        <!-- ภ้าไม่มีความพิการก็ไม่ต้องแสดงประเภทความพิการ -->
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1">
          {{`${dep_permit_date}`}}
        </div>
      </div>
    </div>
    <!-- <div class="flex flex-row py-2 border-b border-theme-39" v-if="is_disabled"> -->
    <div class="flex flex-row py-2" v-if="is_disabled">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        มีบัตรประจำตัวคนพิการ
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2">
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1"
          v-if="have_pwd_card == 1"
        >
          มีบัตร
        </div>
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1"
          v-else-if="have_pwd_card == 2"
        >
          บัตรหมดอายุ
        </div>
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1"
          v-else
        >
          ไม่มีบัตร
        </div>
      </div>
    </div>
    <!-- <div class="flex flex-row py-2 border-b border-theme-39" v-if="is_disabled"> -->
    <div class="flex flex-row py-2"  v-if="dep_card_issue_date">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        วันที่ออกบัตร
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2">
        <!-- <XCircleIcon class="h-6 w-6 text-theme-36" v-if="!is_disabled"/> -->
        <!-- ภ้าไม่มีความพิการก็ไม่ต้องแสดงประเภทความพิการ -->
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1">
          {{`${dep_card_issue_date}`}}
        </div>
      </div>
    </div>
    <div class="flex flex-row py-2"  v-if="dep_card_expire_date">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        วันที่บัตรหมดอายุ
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2">
        <!-- <XCircleIcon class="h-6 w-6 text-theme-36" v-if="!is_disabled"/> -->
        <!-- ภ้าไม่มีความพิการก็ไม่ต้องแสดงประเภทความพิการ -->
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1">
          {{`${dep_card_expire_date}`}}
        </div>
      </div>
    </div>
    <div class="flex flex-row py-2"  v-if="dep_person != '-'">
      <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
        ผู้ดูแลคนพิการ
      </div>
      <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2">
        <div
          class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1">
          {{`${dep_person}`}}
        </div>
      </div>
    </div>

    <!-- ข้อมูลสำรวจเพิ่มเติม (แยกจากข้อมูล DEP) -->
    <div
      v-if="hasMsoSurveyData"
      class="mt-6 pt-4 border-t-2 border-theme-39 rounded-lg border border-theme-39 p-4"
    >
      <div class="text-sm font-semibold text-theme-37 mb-3 pb-2 border-b border-theme-39">
        ข้อมูลสำรวจเพิ่มเติม
      </div>
      <div class="flex flex-row py-2" v-if="mso_survey_disability?.length > 0">
        <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
          ประเภทความพิการ
        </div>
        <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2 flex-wrap">
          <div
            class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center m-1"
            v-for="(data, key) in mso_survey_disability"
            :key="key"
          >
            {{ data.desc }}
          </div>
        </div>
      </div>
      <div class="flex flex-row py-2" v-if="mso_survey_need_pwd_card != null">
        <div class="w-4/12 lg:w-2/12 my-2 flex justify-start items-center px-2">
          ประสงค์มีบัตรประจำตัวคนพิการ
        </div>
        <div class="w-8/12 lg:w-8/12 flex justify-start items-center px-2">
          <div
            class="px-1.5 py-1 border border-theme-39 text-theme-37 rounded-md flex justify-center items-center mx-1"
          >
            {{ mso_survey_need_pwd_card === 1 ? "ประสงค์" : "ไม่ประสงค์" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
const props = defineProps({
  information: Object,
});
const chronic_disease = computed(() => {
  let result = []
  if(props.information.chronic_disease?.length > 0){
    result =[...props.information.chronic_disease]
  }
  return result
});
const med_scheme = computed(()=>{
  let result = []
  if(props.information.med_scheme?.length > 0){
    result =[...props.information.med_scheme]
  }
  return result
})
const dep_person = computed(() => {
  const dep = props.information?.dep;
  if (!dep?.curator_first_name && !dep?.curator_last_name) {
    return "-";
  }
  const prefix = dep.curator_prefix_name || "";
  const first = dep.curator_first_name || "";
  const last = dep.curator_last_name || "";

  let relation = "";
  // รหัส 07 คือ อื่นๆ
  if (dep.curator_relation_code === "07") {
    relation = dep.curator_relation_other || "ไม่ระบุความสัมพันธ์";
  } else {
    relation = dep.curator_relation_name || "ไม่ระบุความสัมพันธ์";
  }

  const fullName = [prefix + first, last].filter(Boolean).join(" ");
  
  return `${fullName} (${relation})`.trim();
});
const dep_card_expire_date = computed(() => props.information.dep?.card_expire_date || null);
const dep_card_issue_date  = computed(() => props.information.dep?.card_issue_date || null);
const dep_permit_date      = computed(() => props.information.dep?.permit_date || null);

const mapSubtypeToThai = (code) => {
  const mapping = {
    Current: "คนพิการจดทะเบียน",
    Out: "เสียชีวิต",
    Normal: "หายจากความพิการ",
    Well: "ยังไม่เข้าเกณฑ์คนพิการ",
    Cancel: "ยกเลิก",
    NoCard: "ไม่ประสงค์มีบัตรประจำตัวคนพิการ",
    IsNot: "ไม่ได้เป็นคนพิการ",
    Wait: "อยู่ระหว่างการอนุมัติจากนายทะเบียน...",
    Expire: "บัตรหมดอายุ",
    Caution: "บุคคลที่อาจไม่เข้าเกณฑ์ความพิการ",
    NoRequest: "ไม่มีแบบคำขอมีบัตร",
    IncFLName: "ชื่อ-นามสกุลไม่ตรงกับกรมการปกครอง",
    Again: "แบบคำขอไม่อนุมัติ จนท.ต้องบันทึกคำขอใหม่",
    NoComplete: "ข้อมูลไม่สมบูรณ์",
    InIDP: "อยู่ในสถานสงเคราะห์ฯ ของ พก.",
    InCentral: "อยู่ในทะเบียนบ้านกลาง",
  };

  if (!code || code === "-") {
    return "-";
  }

  return mapping[code] || code;
};

const dep_person_subtype = computed(() => {
  const code = props.information.dep?.person_subtype || null;
  const text = mapSubtypeToThai(code);
  return text === "-" ? null : text;
});
// const depData = computed(() => {
//   const { 
//     card_expire_date: expire, 
//     card_issue_date: issue, 
//     permit_date: permit, 
//     person_subtype: subtype 
//   } = props.information.dep || {};

//   return {
//     expire: expire || null,
//     issue: issue || null,
//     permit: permit || null,
//     subtype: subtype || null
//   };
// });
const is_DEPlinkingsystem = computed(()=>{
  return props.information.linking_system?.find(i => i.system === 'DEP') ? true : false;
})
const is_disabled = computed(()=>{
  return props.information.is_disabled?.valueOf() != undefined ? props.information.is_disabled : null
})
const have_pwd_card = computed(()=>{
  return props.information.have_pwd_card?.valueOf() != undefined ? props.information.have_pwd_card : null
})
const disability = computed(()=>{
  let result = []
  if(props.information.disability?.length > 0){
    result =[...props.information.disability]
  }
  return result
})
const mso_survey_disability = computed(() => {
  const arr = props.information?.mso_survey?.disability
  return Array.isArray(arr) && arr.length > 0 ? [...arr] : []
})
const mso_survey_need_pwd_card = computed(() => {
  const v = props.information?.mso_survey?.need_pwd_card
  return v !== undefined && v !== null ? v : null
})
const hasMsoSurveyData = computed(() => {
  return (mso_survey_disability.value?.length > 0) || (mso_survey_need_pwd_card.value != null)
})
</script>
